<template>
    <div class="doc-page">
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <div v-if="msgAlerta" class="info-alert row-space" @click="msgAlerta=null">
            <span class="text">{{ msgAlerta }}</span>
        </div>


        <div class="doc-header-card row-space">
            <div class="doc-header-content">
                <div>
                    <div class="doc-title">{{ estabelecimentoSelecionado?.nmestabelecimento }}</div>
                    <div class="doc-subtitle">{{ estabelecimentoSelecionado?.nmatividade }}</div>
                    <div class="doc-subtitle">
                        CPF/CNPJ: {{ estabelecimentoSelecionado?.cpfcnpj || 'Não Informado' }}
                        {{ '   -   ' }}
                        {{ estabelecimentoSelecionado?.nmsim }}
                    </div>
                </div>

                <button class="btn-small" @click="closeForm">Sair</button>
            </div>
        </div>


        <div class="doc-group-card row-space">
            <div>
                <div class="doc-group-title">{{ grupoSelecionado?.nmtpdocgrupo }}</div>
                <div class="doc-group-info">{{ grupoSelecionado?.informacoes }}</div>
            </div>

            <div class="doc-summary">
                <div class="summary-item obrigatorio">
                    <strong>{{ grupoSelecionado?.ttobrigatorios || 0 }}</strong>
                    <span>Obrigatórios</span>
                </div>
                <div class="summary-item acessorio">
                    <strong>{{ grupoSelecionado?.ttacessorios || 0 }}</strong>
                    <span>Acessórios</span>
                </div>
                <div class="summary-item vencido">
                    <strong>{{ grupoSelecionado?.vencidos || 0 }}</strong>
                    <span>Vencidos</span>
                </div>
                <div class="summary-item analise">
                    <strong>{{ grupoSelecionado?.analise || 0 }}</strong>
                    <span>Em análise</span>
                </div>
                <div class="summary-item regular">
                    <strong>{{ grupoSelecionado?.regulares || 0 }}</strong>
                    <span>Regulares</span>
                </div>
                <div class="summary-item vencido">
                    <strong>{{ grupoSelecionado?.pendentes || 0 }}</strong>
                    <span>Pendentes</span>
                </div>
            </div>
        </div>

        <div class="doc-layout row-space">
            <section class="doc-types-panel">
                <!-- <div class="panel-title">Tipos de documento</div> -->

                <div
                    v-for="obj in lsTipos"
                    :key="obj.id"
                    class="doc-type-card"
                    :class="{ selected: tipoDocSelecionado?.id === obj.id }"
                    @click="selecionarTipoDoc(obj)"
                >
                    <div class="type-main">
                        <div class="type-name">{{ obj.nmtpdoc }}</div>
                        <div class="type-meta">
                            <span :class="obj.ckobrigatorio === 'S' ? 'tag required' : 'tag optional'">
                                {{ obj.ckobrigatorio === 'S' ? 'Obrigatório' : 'Acessório' }}
                            </span>

                            <span class="tag prazo">
                                {{ obj.pztiponm || 'Sem prazo' }}
                            </span>
                        </div>
                    </div>

                    <div class="type-arrow">›</div>
                </div>
            </section>


            <section class="doc-anexos-panel">
                <div class="anexos-header">
                    <div>
                        <div class="panel-title">Anexos do tipo selecionado</div>
                        <div class="selected-doc-name">
                            {{ tipoDocSelecionado?.nmtpdoc || 'Selecione um tipo de documento' }}
                        </div>
                    </div>

                    <button
                        v-if="tipoDocSelecionado && !modoEdicao"
                        class="btn-small"
                        @click="novoAnexo"
                    >
                        Adicionar
                    </button>
                </div>


                <div v-if="modoEdicao" class="doc-inline-form">
                    <div v-if="msgAlertaForm" class="info-alert row-space" @click="msgAlertaForm=null">
                        <span class="text">{{ msgAlertaForm }}</span>
                    </div>

                    <div class="inline-form-header">
                        <strong>Novo anexo</strong>
                    </div>

                    <div class="row row-space">
                        <div class="form-item">
                            <AnexoUploadField
                                ref="uploaderRef"
                                :maxSizeMB="20"
                                @selected="onArquivoSelecionado"
                                @cleared="onArquivoLimpo"
                            />
                        </div>
                    </div>

                    <div class="row row-space">
                        <div class="form-item">
                            <label class="label-caption">Nome/Identificação</label>
                            <input type="text" v-model="edNomeDoc" maxlength="100" v-uppercase />
                        </div>

                        <div v-if="tipoDocSelecionado.ckvalidade === 'S'" class="form-item-char15">
                            <label class="label-caption">Válido até</label>
                            <input type="date" v-model="edValidade" />
                        </div>
                    </div>

                    <div class="row row-space">
                        <div class="form-item">
                            <label class="label-caption">Informações</label>
                            <textarea v-model="edInfo" maxlength="1000" rows="3" />
                        </div>
                    </div>

                    <div class="row-end">
                        <button class="btn-small" @click="salvarDoc">Enviar</button>
                        <button class="btn-small" @click="modoEdicao = false">Fechar</button>
                    </div>
                </div>


                <div class="anexos-body">
                    <div v-if="isLoadingAnexos" class="local-loader">
                        Carregando anexos...
                    </div>

                    <template v-else>
                        <div v-if="!tipoDocSelecionado" class="empty-state">
                            Selecione um tipo de documento à esquerda para consultar os anexos.
                        </div>

                        <div v-else-if="lsAnexos.length === 0" class="empty-state">
                            Nenhum anexo encontrado para este tipo de documento.
                        </div>

                        <div v-else class="anexo-list">
                            <div
                                v-for="anexo in lsAnexos"
                                :key="anexo.id"
                                class="anexo-card"
                                :class="classeSituacaoAnexo(anexo)"
                            >
                                <div class="anexo-main">
                                    <div class="anexo-title">
                                        {{ anexo.nmdoc || anexo.nmtpdoc }}
                                    </div>

                                    <div class="anexo-meta">
                                        <span>Anexado em: {{ formatDataBR(anexo.dtanexo) }}</span>
                                        <span>Validade: {{ formatDataBR(anexo.dtvalidade) }}</span>
                                        <span>{{ anexo.tiponm }}</span>
                                    </div>
                                </div>

                                <div class="anexo-status">
                                    <span class="status-badge">{{ anexo.situacaonm }}</span>
                                    <strong>{{ anexo.stvencimento }}</strong>
                                </div>

                                <div class="anexo-actions">
                                    <button class="btn-mini" @click="lerAnexo(anexo)">Baixar</button>
                                    <button class="btn-mini danger" @click="cancelarAnexo(anexo)">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </section>
        </div>
    </div>


    <EstabelecimentoPesquisaModal
        :showModal="showModalEstabelecimento"
        @close="showModalEstabelecimento = false"
        @objSelecionado="setEstabelecimento"
    />
    
    <ModalJustificativa ref="modalJustificativa" />
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import AnexoUploadField from '@/fields/AnexoUploadField.vue';
import EstabelecimentoPesquisaModal from '../modals/EstabelecimentoPesquisaModal.vue';
import ModalJustificativa from '../modals/ModalJustificativa.vue';

const emit = defineEmits(['close']);
const props = defineProps({idGrupo: Number});

const estabelecimentoSelecionado = ref(null);
const grupoSelecionado = ref(null);
const tipoDocSelecionado = ref(null);
const lsAnexos = ref([]);
const lsTipos = ref([]);

const isLoading = ref(false);
const isLoadingAnexos = ref(false);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const msgAlertaForm = ref(null);
const showModalEstabelecimento = ref(false);

const edInfo = ref(null);
const edNomeDoc = ref(null);
const edValidade = ref(null);
const uploaderRef = ref(null);

const modalJustificativa = ref(null);


async function atualizaResumo(){
    try{
        isLoadingAnexos.value = true; // FAZER LOADER PARA O RESUMO
        const req = await Api.genericPost('/dados/estabelecimento/docgrupo', {
            id: props.idGrupo,
            idep: globalStore.idep,
            idestabelecimento: estabelecimentoSelecionado.value.id});
        grupoSelecionado.value = req[0];
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoadingAnexos.value = false;}

}


async function cancelarAnexo(obj) {
    const rModal = await modalJustificativa.value.show();

    if (!rModal.confirmado) return;

    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await Api.genericPut('/cad/anexo', {
            id: obj.id, 
            cancelamentoidlogin: globalStore.idlogin, 
            cancelamentoobs: rModal.justificativa});
        if (r.bolok==1){
            await atualizaResumo();
            await lerAnexosPorTipo();
        }else{msgAlerta.value=r.erro}
    }catch (error){msgAlerta.value=error;
    }finally{isLoading.value=false;}
}


const closeForm = () => {emit('close');}


async function lerAnexo(obj) {
    try{
        msgAlerta.value=null;
        isLoadingAnexos.value = true;
        const r = await Api.genericPost('/operacoes/solicitar/download', {id: obj.idanexo || obj.id});
        if (r.bolok === 1){
            const url = r.download_url;
            window.open(url, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoadingAnexos.value = false;}
}


async function lerAnexosPorTipo() {
    try{
        msgAlerta.value = null;
        isLoadingAnexos.value = true;

        const r = await Api.genericPost('/listas/anexos', {
            idep: globalStore.idep,
            idestabelecimento: estabelecimentoSelecionado.value.id,
            intparam2: tipoDocSelecionado.value.id,
            ativo: 'S'});
        lsAnexos.value = r;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoadingAnexos.value = false;}
}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;

        const req = await Api.genericPost('/dados/estabelecimento/docgrupo', {
            id: props.idGrupo,
            idep: globalStore.idep,
            idestabelecimento: estabelecimentoSelecionado.value.id});
        grupoSelecionado.value = req[0];

        if (!grupoSelecionado.value) throw new Error('Nenhum grupo de documentos foi definido');
        
        const reqLista = await Api.genericPost('/listas/tpdocs', {
            idep: globalStore.idep,
            idreferencia: grupoSelecionado.value.id});
        lsTipos.value = reqLista;

        if (reqLista.length > 0) {
            await selecionarTipoDoc(reqLista[0]);
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function onArquivoSelecionado(file) {
    if (!file) return;
    edNomeDoc.value = file.name.replace(/\.[^/.]+$/, '');
}


function onArquivoLimpo() {
    edNomeDoc.value = null;
}


async function salvarDoc(){
    msgAlertaForm.value = validarDadosAnexo();
    if (msgAlertaForm.value) return;

    try{
        isLoading.value = true;
        const file = uploaderRef.value.getFile();
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        const payloadAnexo = {
            idep: globalStore.idep,
            idestabelecimento: estabelecimentoSelecionado.value.id,
            idanexogrupo: 1,
            idtpdoc: tipoDocSelecionado.value.id,
            idlogin: globalStore.idlogin,
            dtvalidade: edValidade.value,
            nmdoc: edNomeDoc.value,
            obspostagem: edInfo.value,
            tipo: file.type === 'application/pdf' ? '0' : '1',
            fname: file.name,
            file_ext: ext,
            mime_type: file.type || 'application/octet-stream'
        };

        await uploaderRef.value.upload(payloadAnexo);
        await atualizaResumo();
        await lerAnexosPorTipo();

        edNomeDoc.value = null;
        edValidade.value = null;
        edInfo.value = null;
        modoEdicao.value = false;
        uploaderRef.value.clear();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function setEstabelecimento(obj) {
    estabelecimentoSelecionado.value = obj;
    lerDados();
}


async function startForm(){
    if (globalStore.idestabelecimento > 0){
        estabelecimentoSelecionado.value = {
            id: globalStore.idestabelecimento,
            nmestabelecimento: globalStore.nmestabelecimento,
            nmatividade: globalStore.atividade.nmatividade
        }
        lerDados();
    }else{
        showModalEstabelecimento.value = true;
    }
}


function validarDadosAnexo(){
    let x = '';
    if (!uploaderRef.value?.hasFile()) x += '\n-Necessário selecionar um arquivo';
    let r = Validar.texto(edNomeDoc.value, '\n-Informe nome ou identificação do anexo');
    if (!r.ok) x += r.msg;
    if (tipoDocSelecionado.value.ckvalidade === 'S'){
        r = Validar.data(edValidade.value);
        if (!r.ok) x += '\n-Verifique a data de validade';
    }
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


//-----------------------------------------------------------
async function selecionarTipoDoc(obj) {
    tipoDocSelecionado.value = obj;
    modoEdicao.value = false;
    await lerAnexosPorTipo();
}

function novoAnexo() {
    edNomeDoc.value = null;
    edValidade.value = null;
    edInfo.value = null;
    modoEdicao.value = true;
}

function formatDataBR(value) {
    if (!value) return '-';

    const [ano, mes, dia] = value.substring(0, 10).split('-');
    if (!ano || !mes || !dia) return value;

    return `${dia}/${mes}/${ano}`;
}

function classeSituacaoAnexo(anexo) {
    if (anexo.stvencimento === 'VENCIDO') return 'vencido';
    if (anexo.situacaonm === 'À CONFERIR') return 'analise';
    return 'regular';
}
//-----------------------------------------------------------


onMounted(startForm)
</script>


<style scoped>
.doc-page {
    text-align: left;
}

.doc-header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.doc-header-content .btn-small {
    flex: 0 0 auto;
}

.summary-item,
.summary-item * {
    text-align: center;
}

.anexo-status,
.anexo-status * {
    text-align: center;
}

.doc-inline-form {
    border: 1px solid #cbd5e1;
    border-left: 5px solid #2563eb;
    background: #f8fafc;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 12px;
}

.inline-form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.inline-form-header strong {
    font-size: 14px;
    color: #1f2937;
}

.anexos-body {
    position: relative;
    min-height: 90px;
}

.local-loader {
    border: 1px dashed #cbd5e1;
    background: #f8fafc;
    border-radius: 10px;
    padding: 18px;
    color: #64748b;
    font-size: 13px;
    text-align: center;
}

.doc-header-card,
.doc-group-card {
    background: #fff;
    border: 1px solid #d9e2ec;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.doc-title {
    font-size: 20px;
    font-weight: 700;
    color: #1f2937;
}

.doc-subtitle {
    font-size: 13px;
    color: #64748b;
    margin-top: 3px;
}

.doc-group-card {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
}

.doc-group-title {
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
}

.doc-group-info {
    font-size: 13px;
    color: #64748b;
    margin-top: 4px;
}

.doc-summary {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.summary-item {
    min-width: 82px;
    border-radius: 10px;
    padding: 8px;
    text-align: center;
    border: 1px solid #e5e7eb;
    background: #f8fafc;
}

.summary-item strong {
    display: block;
    font-size: 18px;
}

.summary-item span {
    font-size: 11px;
    color: #64748b;
}

.summary-item.vencido strong { color: #b91c1c; }
.summary-item.analise strong { color: #b45309; }
.summary-item.regular strong { color: #15803d; }

.doc-layout {
    display: grid;
    grid-template-columns: 38% 1fr;
    gap: 14px;
    align-items: start;
}

.doc-types-panel,
.doc-anexos-panel {
    background: #fff;
    border: 1px solid #d9e2ec;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
}

.panel-title {
    font-size: 15px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 10px;
}

.doc-type-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border: 1px solid #e5e7eb;
    background: #f8fafc;
    border-radius: 10px;
    padding: 11px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: 0.15s ease;
}

.doc-type-card:hover {
    border-color: #94a3b8;
    background: #f1f5f9;
}

.doc-type-card.selected {
    border-color: #2563eb;
    background: #eff6ff;
    box-shadow: inset 4px 0 0 #2563eb;
}

.type-name {
    font-size: 13px;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.25;
}

.type-meta {
    display: flex;
    gap: 6px;
    margin-top: 7px;
    flex-wrap: wrap;
}

.tag {
    font-size: 10px;
    padding: 3px 7px;
    border-radius: 999px;
    border: 1px solid transparent;
}

.tag.required {
    background: #fee2e2;
    color: #991b1b;
    border-color: #fecaca;
}

.tag.optional {
    background: #e0f2fe;
    color: #075985;
    border-color: #bae6fd;
}

.tag.prazo {
    background: #f1f5f9;
    color: #475569;
    border-color: #e2e8f0;
}

.type-arrow {
    font-size: 26px;
    color: #64748b;
}

.anexos-header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 12px;
    margin-bottom: 12px;
}

.selected-doc-name {
    font-size: 13px;
    color: #64748b;
    margin-top: -6px;
}

.empty-state {
    border: 1px dashed #cbd5e1;
    background: #f8fafc;
    border-radius: 10px;
    padding: 22px;
    color: #64748b;
    text-align: center;
    font-size: 13px;
}

.anexo-card {
    display: grid;
    grid-template-columns: 1fr 140px 120px;
    gap: 12px;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 9px;
    background: #fff;
}

.anexo-card.vencido {
    border-left: 5px solid #dc2626;
}

.anexo-card.analise {
    border-left: 5px solid #f59e0b;
}

.anexo-card.regular {
    border-left: 5px solid #16a34a;
}

.anexo-title {
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
}

.anexo-meta {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 11px;
    color: #64748b;
    margin-top: 5px;
}

.anexo-status {
    text-align: center;
}

.status-badge {
    display: inline-block;
    font-size: 10px;
    padding: 4px 7px;
    border-radius: 999px;
    background: #f1f5f9;
    color: #475569;
    margin-bottom: 4px;
}

.anexo-status strong {
    display: block;
    font-size: 12px;
    color: #334155;
}

.anexo-actions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
}

.btn-mini {
    width: auto;
    min-width: 60px;
    font-size: 11px;
    padding: 5px 8px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    background: #f8fafc;
    cursor: pointer;
}

.btn-mini:hover {
    background: #e2e8f0;
}

.btn-mini.danger {
    color: #b91c1c;
}

@media (max-width: 1000px) {
    .doc-layout {
        grid-template-columns: 1fr;
    }

    .doc-group-card {
        flex-direction: column;
        align-items: stretch;
    }

    .doc-summary {
        justify-content: flex-start;
    }

    .anexo-card {
        grid-template-columns: 1fr;
    }

    .anexo-status,
    .anexo-status * {
        text-align: left;
    }

    .anexo-actions {
        justify-content: flex-start;
    }
}
</style>